var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whiteBox"},[(!_vm.dateRange)?_c('h4',[_vm._v("Orders today")]):_c('h4',[_vm._v("Orders")]),_c('p',{staticClass:"bigNumber"},[_vm._v(_vm._s(_vm.amountOrders))])])}
var staticRenderFns = []

export { render, staticRenderFns }